import Vue from 'vue'
import {mapGetters} from 'vuex'

import {findAttributeOnSiteInfo} from './FindAttributeOnSiteInfo'
import {processContent} from './ContentFunctions'
import {contentSlicer} from './ContentFunctions'

Vue.mixin({
    computed: {
        ...mapGetters({
            siteInfos: "SiteInfo/getSiteInfos"
        })
    },
    methods: {
        findAttributeOnSiteInfo,
        checkGoogleAnalytics() {
            let condition = true;
            let scripts = document.head.querySelectorAll('script')
            if (scripts.length == 0) return condition

            scripts.forEach(function (script) {
                if (script.src.includes('googletagmanager') || script.src != '') {
                    condition = false
                }
            });

            return condition

        },
        processContent,
        contentSlicer,
    },
    watch: {
        '$route': {
            handler: function () {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
        },
        siteInfos: {
            handler: function (newValue, oldValue) {

                if (newValue != undefined) {
                    document.title = this.findAttributeOnSiteInfo('site_name')
                }

                if (this.findAttributeOnSiteInfo('googleAnalytics') != undefined && this.checkGoogleAnalytics()) {
                    document.head.insertAdjacentHTML('beforeend', this.findAttributeOnSiteInfo('googleAnalytics'));
                }


            },
            deep: true
        },
    }
})